module.exports = __webpack_public_path__ + "img/wheat-slash.f4443eb8.svg";